import service from '../../utils/request'

// 查询对接配置
export function findDockingByTaskId(taskId) {
  return service({
    method: 'get',
    url: `/glodon/findDockingByTask`,
    params: {
      taskId,
    },
  })
}
export function findDockingLogByTaskId(taskId) {
  return service({
    method: 'get',
    url: `/glodon/findDockingLogByTask`,
    params: {
      taskId,
    },
  })
}



// 新增对接
export function addDockingByGLD(data) {
  return service({
    method: 'post',
    url: `/glodon/add`,
    data,
  })
}
// 修改
export function updateDockingByGLD(data) {
  return service({
    method: 'put',
    url: `/glodon/update`,
    data,
  })
}
// 删除
export function deleteDockingByGLD(id) {
  return service({
    method: 'delete',
    url: `/glodon/delete`,
    params: { id },
  })
}
//   开启对接
export function sendDockingByGLD(data) {
  return service({
    method: 'get',
    url: `/glodon/startDocking`,
    params: data,
  })
}

//   关闭对接
export function endDockingByGLD(data) {
  return service({
    method: 'get',
    url: `/glodon/endDocking`,
    params: data,
  })
}


